"use client";

import { Button, Heading, HStack, Text } from "@chakra-ui/react";
import GenericIcon from "../actions/GenericIcon";

export type ContentItemDetailModeHeaderProps = {
  onReturn: () => void;
  returnAriaLabel: string;
  returnLabel?: string;
  title: string;
};

export default function ContentItemDetailModeHeader({
  onReturn,
  returnAriaLabel,
  returnLabel = "Return",
  title,
}: ContentItemDetailModeHeaderProps) {
  return (
    <HStack justify="space-between" align="start" gap="4" width="full">
      <Heading size="sm" minW={0}>
        {title}
      </Heading>

      <Button
        type="button"
        variant="outline"
        onClick={onReturn}
        aria-label={returnAriaLabel}
        minW={{ base: "10", sm: "auto" }}
      >
        <GenericIcon icon="return" />
        <Text as="span" display={{ base: "none", sm: "inline" }}>
          {returnLabel}
        </Text>
      </Button>
    </HStack>
  );
}
